"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _count = _interopRequireDefault(require("../poly/count"));
var _menu = require("../utilities/menu");
var _helpers = require("../utilities/helpers");
var _breakpoints = _interopRequireDefault(require("../breakpoints"));
var _mobileMenuItem = _interopRequireDefault(require("./mobileMenuItem"));
var _slideDrawer = _interopRequireDefault(require("./slideDrawer"));
var _excluded = ["component"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var useClasses = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
    zIndex = _ref.zIndex;
  return {
    bottomNavigation: {
      borderTop: "1px solid ".concat(palette.border.primary),
      height: 'inherit',
      zIndex: zIndex.modal + 1,
      display: 'grid',
      gridAutoColumns: '1fr',
      gridTemplateRows: 'max-content',
      alignItems: 'center',
      width: '100%',
      position: 'fixed',
      bottom: 0,
      justifyContent: 'space-around',
      padding: '.5em 0'
    }
  };
}, {
  classNamePrefix: 'TCUISiteMenuMobile'
});
var SiteMobileMenu = function SiteMobileMenu(_ref2) {
  var items = _ref2.items,
    renderItem = _ref2.renderItem,
    getItemChildren = _ref2.getItemChildren,
    getItemKey = _ref2.getItemKey,
    renderMenuItemImage = _ref2.renderMenuItemImage,
    BottomNavigationProps = _ref2.BottomNavigationProps,
    MenuItemProps = _ref2.MenuItemProps,
    SlideDrawerProps = _ref2.SlideDrawerProps;
  var _classes = useClasses();
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = (0, _react.useState)({
      openItem: ''
    }),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    openMenu = _useState4[0],
    setOpenMenu = _useState4[1];
  var handleBottomNavChange = function handleBottomNavChange(value) {
    return setValue(value);
  };
  var handleOpenMenu = function handleOpenMenu(menu) {
    return setOpenMenu(menu);
  };
  var _MenuItemProps$compon = MenuItemProps.component,
    MenuItem = _MenuItemProps$compon === void 0 ? _mobileMenuItem.default : _MenuItemProps$compon,
    restMenuItemProps = (0, _objectWithoutProperties2.default)(MenuItemProps, _excluded);
  if (!(0, _count.default)(items)) return null;
  return /*#__PURE__*/_react.default.createElement(_breakpoints.default, {
    direction: "down",
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(_core.BottomNavigation, (0, _extends2.default)({}, BottomNavigationProps, {
    value: value,
    onChange: handleBottomNavChange,
    classes: (0, _helpers.deepmerge)({
      root: _classes.bottomNavigation
    }, BottomNavigationProps.classes),
    showLabels: false
  }), !!renderItem && items.map(renderItem), !renderItem && items.map(function (item, i) {
    var itemChildren = getItemChildren(item, i);
    var key = getItemKey(item, i);
    if ((0, _count.default)(itemChildren)) {
      return /*#__PURE__*/_react.default.createElement(_slideDrawer.default, (0, _extends2.default)({}, SlideDrawerProps, {
        key: key,
        item: item,
        items: itemChildren,
        setMenu: handleOpenMenu,
        openMenu: openMenu,
        renderMenuItemImage: renderMenuItemImage,
        getItemKey: getItemKey,
        isLastMenuItem: i === items.length - 1
      }));
    }
    return /*#__PURE__*/_react.default.createElement(MenuItem, (0, _extends2.default)({}, restMenuItemProps, {
      key: key,
      item: item,
      isActive: openMenu.openItem !== '',
      isDrawerActive: openMenu.openItem !== '',
      renderMenuItemImage: renderMenuItemImage
    }));
  })));
};
SiteMobileMenu.propTypes = {
  items: _propTypes.default.array,
  renderItem: _propTypes.default.func,
  getItemChildren: _propTypes.default.func,
  getItemKey: _propTypes.default.func,
  renderMenuItemImage: _propTypes.default.func,
  BottomNavigationProps: _propTypes.default.object,
  MenuItemProps: _propTypes.default.object,
  SlideDrawerProps: _propTypes.default.object
};
SiteMobileMenu.defaultProps = {
  getItemKey: _menu.getItemKey,
  items: [],
  renderItem: null,
  getItemChildren: function getItemChildren() {
    return null;
  },
  renderMenuItemImage: function renderMenuItemImage() {
    return null;
  },
  BottomNavigationProps: {},
  MenuItemProps: {},
  SlideDrawerProps: {}
};
var _default = SiteMobileMenu;
exports.default = _default;